// extracted by mini-css-extract-plugin
module.exports = {"subHeader":"myProfile_subHeader__Q28gE","circle":"myProfile_circle__BXaUJ","title":"myProfile_title__2ewRL","form":"myProfile_form__3Vrzb"};